const Layout = () => import('@/layout/index.vue')

export default {
    path: '/course',
    component: Layout,
    redirect: '/course/account',
    name: 'Course',
    meta: {
        title: '课程管理',
        icon: 'course'
    },
    children: [
        {
            path: 'classify',
            name: 'CourseClassify',
            component: () => import('@/views/course/classify/index.vue'),
            meta: {
                title: '课程分类',
                icon: 'course-classify',
                auth: ['course.classify']
            }
        },
        {
            path: 'carousel',
            name: 'CourseCarousel',
            component: () => import('@/views/course/carousel/index.vue'),
            meta: {
                title: '课程走马灯',
                icon: 'course-carousel',
                auth: ['course.carousel']
            }
        },
        {
            path: 'info',
            name: 'CourseInfo',
            component: () => import('@/views/course/info/index.vue'),
            meta: {
                title: '课程信息',
                icon: 'course-info',
                auth: ['course.info']
            }
        },
        {
            path: 'article',
            name: 'CourseArticle',
            component: () => import('@/views/course/article/index.vue'),
            meta: {
                title: '课程文章',
                icon: 'course-article',
                auth: ['course.article']
            }
        },
        {
            path: 'order',
            name: 'CourseOrder',
            component: () => import('@/views/course/order/index.vue'),
            meta: {
                title: '课程订单',
                icon: 'course-order',
                auth: ['course.order']
            }
        }
    ]
}
